export enum Relation {
  And = 'AND',
  Or = 'OR',
  Group = 'GROUP',
}
